/* ===============================
   POPUP LOGIC – GLOBAL
================================ */

const EU_COUNTRIES = [
  "Austria","Belgium","Bulgaria","Croatia","Cyprus","Czech Republic",
  "Denmark","Estonia","Finland","France","Germany","Greece","Hungary",
  "Ireland","Italy","Latvia","Lithuania","Luxembourg","Malta",
  "Netherlands","Poland","Portugal","Romania","Slovakia","Slovenia",
  "Spain","Sweden"
];

function updateLocalizationPopup(countryName) {
  const title = document.querySelector(".popup-title h3");
  const countryLine = document.querySelector(".popup-country");
  const shippingLine = document.querySelector(".popup-shipping-message");

  if (!title || !countryLine || !shippingLine) return;

  title.textContent = `Your location is set to ${countryName}`;
  countryLine.textContent = `Get shipping options for ${countryName}`;

  if (countryName === "Netherlands") {
    shippingLine.innerHTML =
      "Enjoy <strong>FREE SHIPPING</strong> for orders above €120";
    return;
  }

  if (EU_COUNTRIES.includes(countryName)) {
    shippingLine.innerHTML =
      'Please note that all of our products ship from The Netherlands, for more information on shipping inside of the EU, please visit our <a href="/pages/shipping">shipping page</a>';
    return;
  }

  shippingLine.innerHTML =
    'Please note that all of our products ship from The Netherlands, for more information on shipping and what this means if you are outside of the EU, please visit our <a href="/pages/shipping">shipping page</a>';
}

function applyPopupFromCurrentCountry() {
  const countryInput = document.querySelector(
    '#HeaderCountryForm input[name="country_code"]'
  );
  if (!countryInput || !countryInput.value) return;

  const countryCode = countryInput.value;
  const countryOption = document.querySelector(
    `.country-selector a[data-value="${countryCode}"]`
  );

  const countryName =
    countryOption?.dataset.full_detail ||
    countryOption?.querySelector(".country")?.innerText;

  if (countryName) updateLocalizationPopup(countryName.trim());
}

document.addEventListener("DOMContentLoaded", applyPopupFromCurrentCountry);

/* ===============================
   LOCALIZATION DROPDOWNS
================================ */

if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper")
        };

        if (this.elements.button) {
          this.elements.button.addEventListener("click", () => {
            if (!this.elements.panel) return;
            this.elements.panel.toggleAttribute("hidden");
            this.elements.button.setAttribute(
              "aria-expanded",
              (!this.elements.panel.hasAttribute("hidden")).toString()
            );
          });
        }

        this.querySelectorAll("a").forEach(item =>
          item.addEventListener("click", this.onItemClick.bind(this))
        );
      }

      closePanel() {
        if (!this.elements.panel) return;
        this.elements.panel.setAttribute("hidden", true);
        if (this.elements.button) {
          this.elements.button.setAttribute("aria-expanded", "false");
        }
      }

      onItemClick(event) {
        event.preventDefault();

        const form = this.querySelector("form");
        if (!form || !this.elements.input) return;

        /* Update UI label + checkmark */
        const wrapper = event.currentTarget.closest("localization-form");
        if (wrapper) {
          wrapper.querySelectorAll(".lozalization_list_anchor_tag span")
            .forEach(span => span.classList.add("visibility-hidden"));

          event.currentTarget.querySelector("span")
            ?.classList.remove("visibility-hidden");

          const label = wrapper.querySelector(".localization_active_detail_lable");
          if (label && event.currentTarget.dataset.full_detail) {
            label.innerText = event.currentTarget.dataset.full_detail;
          }
        }

        /* Mark form changed */
        form.classList.add("form_value_changed");

        /* Set correct value */
        if (this.elements.input.name === "locale_code") {
          this.elements.input.value =
            event.currentTarget.dataset.value ||
            event.currentTarget.dataset.locale;
        } else {
          this.elements.input.value = event.currentTarget.dataset.value;
        }

        /* Update popup only for country */
        if (this.elements.input.name === "country_code") {
          const countryName =
            event.currentTarget.dataset.full_detail ||
            event.currentTarget.querySelector(".country")?.innerText;

          if (countryName) updateLocalizationPopup(countryName.trim());
        }

        this.closePanel();
      }
    }
  );
}

/* ===============================
   CONFIRM BUTTON – FINAL LOGIC
================================ */

window.localization_submit_click = (submit_btn) => {
  const langForm = document.querySelector("#HeaderLanguageForm");
  const countryForm = document.querySelector("#HeaderCountryForm");

  const langChanged = langForm?.classList.contains("form_value_changed");
  const countryChanged = countryForm?.classList.contains("form_value_changed");

  submit_btn.classList.add("active");

  /* 🔴 LANGUAGE CHANGE MUST BE NATIVE SUBMIT */
  if (langChanged) {
    langForm.submit();
    return;
  }

  /* Country-only can be AJAX */
  if (countryChanged) {
    fetch(countryForm.action, {
      method: "POST",
      body: new FormData(countryForm),
      credentials: "same-origin"
    })
    .then(() => window.location.reload())
    .catch(console.error);
  }
};

/* ===============================
   POPUP OPEN / CLOSE
================================ */

window.close_localization = () => {
  document.querySelector(".localization_wrapper_containor")
    ?.classList.add("hide_localization");
  document.querySelector(".localization_overlap")
    ?.classList.remove("localization_overlap_show");
};

window.open_localization = () => {
  document.querySelector(".localization_wrapper_containor")
    ?.classList.remove("hide_localization");
  document.querySelector(".localization_overlap")
    ?.classList.add("localization_overlap_show");
};